// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest
 */
export interface V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest {
  /**
   *
   * @type {number}
   * @memberof V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest
   */
  maxFilterCount?: number;
}

/**
 * Check if a given object implements the V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest interface.
 */
export function instanceOfV1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest(
  value: object,
): value is V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest {
  return true;
}

export function V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequestFromJSON(
  json: any,
): V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest {
  return V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequestFromJSONTyped(
    json,
    false,
  );
}

export function V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest {
  if (json == null) {
    return json;
  }
  return {
    maxFilterCount:
      json['maxFilterCount'] == null ? undefined : json['maxFilterCount'],
  };
}

export function V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequestToJSON(
  json: any,
): V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest {
  return V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequestToJSONTyped(
    json,
    false,
  );
}

export function V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequestToJSONTyped(
  value?: V1IpFiltersOrchestraTenantidDbidMaxFilterCountPutRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    maxFilterCount: value['maxFilterCount'],
  };
}
